/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * This is the Globe component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Globe({ title, ...props }) {
  return (
    <span className="svg svg-square svg-globe" {...props}>
      <span>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{title}</title>
          <path
            d="M9.00039 0C4.03438 0 0 4.03438 0 9.00039C0 13.9664 4.03438 18 9.00039 18C13.9664 18 18 13.9664 18 9.00039C18 4.03438 13.9664 0 9.00039 0ZM10.7927 1.10488C12.8459 1.56781 14.6022 2.80408 15.7356 4.49799L13.1459 4.49814C12.7119 3.40819 12.1539 2.54762 11.5882 1.89706C11.3199 1.58844 11.0509 1.32955 10.7927 1.10503L10.7927 1.10488ZM7.20355 1.10579C6.94526 1.33016 6.67613 1.58862 6.40805 1.89692C5.84236 2.54745 5.28539 3.40806 4.85217 4.49801L2.2618 4.49816C3.39516 2.80514 5.1516 1.56963 7.2039 1.10594L7.20355 1.10579ZM9.44853 1.20509C9.83793 1.45614 10.365 1.86136 10.9104 2.48855C11.3572 3.00239 11.8025 3.66784 12.1735 4.49802L9.44869 4.49817L9.44853 1.20509ZM8.54757 1.20675V4.49782H5.82608C6.19708 3.66765 6.64237 3.0022 7.08917 2.48835C7.63256 1.86344 8.15848 1.45808 8.54742 1.20671L8.54757 1.20675ZM1.74723 5.3989H4.53908C4.27205 6.30774 4.09498 7.35398 4.05914 8.55195L0.919327 8.5521C0.981112 7.42284 1.27059 6.35773 1.74738 5.39906L1.74723 5.3989ZM5.48391 5.3989H8.5473V8.55195L4.95845 8.5521C4.99687 7.3181 5.19759 6.28285 5.48406 5.39906L5.48391 5.3989ZM9.44846 5.3989H12.5153C12.8019 6.2827 13.0025 7.31811 13.0409 8.55195L9.44876 8.5521L9.44846 5.3989ZM13.4597 5.3989H16.2497C16.7261 6.35762 17.0152 7.42269 17.0769 8.55195L13.9407 8.5521C13.9048 7.3541 13.7274 6.30785 13.4598 5.39906L13.4597 5.3989ZM0.919482 9.45218H4.05945C4.09547 10.6488 4.27253 11.6937 4.53939 12.6018L1.74858 12.6021C1.27223 11.6443 0.98186 10.5806 0.919636 9.45249L0.919482 9.45218ZM4.95964 9.45218H8.54792V12.6018L5.48468 12.6021C5.19821 11.719 4.99853 10.6852 4.95995 9.45249L4.95964 9.45218ZM9.44884 9.45218H13.0405C13.0018 10.6848 12.8022 11.7187 12.5157 12.6018L9.449 12.6021L9.44884 9.45218ZM13.9407 9.45218H17.0771C17.0148 10.5802 16.7251 11.644 16.249 12.6018L13.46 12.6021C13.7275 11.694 13.9047 10.6491 13.9409 9.45249L13.9407 9.45218ZM2.2608 13.502H4.85225C5.28547 14.5923 5.84228 15.4524 6.40813 16.1031C6.67621 16.4114 6.94551 16.6698 7.20363 16.8942C5.15106 16.4305 3.39415 15.1955 2.26076 13.502H2.2608ZM5.82616 13.502H8.54765V16.794C8.15887 16.5429 7.63295 16.1376 7.08955 15.5127C6.6426 14.9987 6.19746 14.3327 5.82647 13.5023L5.82616 13.502ZM9.44861 13.502H12.1736C11.8024 14.3324 11.3573 14.9984 10.9105 15.5124C10.3651 16.1395 9.83816 16.5446 9.44861 16.7958V13.502ZM13.1458 13.502H15.7363C14.603 15.1967 12.8458 16.4322 10.7916 16.8951C11.0498 16.6706 11.3194 16.4118 11.588 16.1031C12.1538 15.4524 12.7117 14.5923 13.1457 13.502H13.1458Z"
            fill="currentColor"
          />
        </svg>
      </span>
    </span>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Globe.propTypes = {
  title: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Globe.defaultProps = {
  title: 'Globe',
};

export default Globe;
